import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  LOCAL_PRODUCT_DEFINITION,
  ScreenEngineResolver,
  ScreenEngineScreenModel
} from '@opengamma/ui';
import { Observable } from 'rxjs';
import * as fromUser from 'app/user-auth/store/user-auth.selectors';
import { filterUndefined } from '../rxjs/rxjs.utils';
import { map } from 'rxjs/operators';
import { carmaApiPath } from 'environments/environment.utils';
import { findScreenByUrlPath } from '../utils/resolver.utils';

@Injectable()
export class CarmaScreenEngineResolver extends ScreenEngineResolver {
  constructor(private store: Store) {
    super();
  }

  getScreen(): Observable<ScreenEngineScreenModel> {
    return this.store.pipe(select(fromUser.getScreensByUrl), filterUndefined()).pipe(
      map(screenMap => ({
        id: screenMap[location.pathname]?.screenPermission,
        definition: screenMap[location.pathname]?.definition,
        screenName: screenMap[location.pathname]?.screenName
      }))
    );
  }

  getScreenUrl(): string {
    return location.pathname;
  }

  getScreenId(): string {
    return findScreenByUrlPath(LOCAL_PRODUCT_DEFINITION(carmaApiPath()), location.pathname);
  }

  getScreenUrlPathForDownload(downloadPath: string): string {
    return `${carmaApiPath()}/${this.getScreenUrl()}/${downloadPath}`;
  }

  observeDatepickerChanges(): boolean {
    return false;
  }
}
